(function () {
    'use strict';

    angular.module("imApp").factory("businessCoBankAccountService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3355,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3356,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
